import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { EstateComparisonTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { EstateComparisonReportSchemaObject } from '../EstateComparisonReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = "ESTATECOMPARISONREPORT";

export function EstateComparisonListing(props) {

    const componentRef = useRef();
    const [csvTotalRow, setCsvTotalRow] = useState([]);
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [estateComparisonDetails, setEstateComparisonDetails] = useState({
        groupID: "0",
        estateID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: "0",
        estateID: "0",
        fromDate: "",
        toDate: ""
    });

    const csvHeaders = [
        { label: "Date", value: "dateTime" },
        { label: "Plucking Gross Weight", value: "" },
        { label: "Plucking Rounded Weight", value: "pluckingRoundedWeight" },
        { label: "Plucking Deduction", value: "pluckingDeduction" },
        { label: "Plucking NetWeight", value: "pluckingNetWeight" },
        { label: "Field Bag Count", value: "fieldBagCount" },
        { label: "Field Gross Weight", value: "fieldGrossWeight" },
        { label: "Field NetWeight", value: "fieldNetWeight" },
        { label: "Field Per Bag Average", value: "fieldPerBagAverage" },
        { label: "Factory Bag Count", value: "factoryBagCount" },
        { label: "Factory Gross Weight", value: "factoryGrossWeight" },
        { label: "Factory Deduction", value: "factoryDeduction" },
        { label: "Factory Net Weight", value: "factoryNetWeight" },
        { label: "Factory Per Bag Average", value: "factoryPerBagAverage" },
        { label: "Other Estates Gross Weight", value: "otherEstatesGrossWeight" },
    ];

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(EstateComparisonReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["date", "pluckingGrossWeight", "pluckingNetWeight", "pluckingDeduction", "pluckingRoundedWeight",
        "fieldBagCount", "fieldGrossWeight", "fieldNetWeight", "fieldPerBagAverage",
        "factoryBagCount", "factoryGrossWeight", "factoryDeduction", "factoryNetWeight", "factoryPerBagAverage", "otherEstatesGrossWeight"]


    const [totalCollections, setTotalCollections] = useState({
        pluckingGrossWeight: 0, 
        pluckingRoundedWeight: 0,
        pluckingDeduction: 0,
        pluckingNetWeight: 0,
        fieldBagCount: 0,
        fieldGrossWeight: 0,
        fieldNetWeight: 0,
        fieldPerBagAverage: 0,
        factoryBagCount: 0,
        factoryGrossWeight: 0,
        factoryDeduction: 0,
        factoryNetWeight: 0,
        factoryPerBagAverage: 0,
        otherEstatesGrossWeight: 0

    });

    const [reportData, setReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [estateComparisonDetails.groupID])


    useEffect(() => {
    }, [reportData]);


    function handleGroupChange(target) {
        validateInputs(target);

        setEstateComparisonDetails({
            ...estateComparisonDetails,
            groupID: target.value,
            estateID: "0",

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setEstateComparisonDetails({
            ...estateComparisonDetails,
            estateID: target.value,

        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setEstateComparisonDetails({
            ...estateComparisonDetails,
            fromDate: target.value
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setEstateComparisonDetails({
            ...estateComparisonDetails,
            toDate: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, EstateComparisonReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWESTATECOMPARISONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setEstateComparisonDetails({
            ...estateComparisonDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(estateComparisonDetails.groupID);
        setEstates(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();

        let totalOfData = {
            dateTime: "Total",
            pluckingGrossWeight: 0,
            pluckingRoundedWeight: 0,
            pluckingDeduction: 0,
            pluckingNetWeight: 0,
            fieldBagCount: 0,
            fieldGrossWeight: 0,
            fieldNetWeight: 0,
            fieldPerBagAverage: 0,
            factoryBagCount: 0,
            factoryGrossWeight: 0,
            factoryDeduction: 0,
            factoryNetWeight: 0,
            factoryPerBagAverage: 0,
            otherEstatesGrossWeight: 0,
        }

        setIsTableHide(true);
        setButtonHide(true);

        const errorMessages = validate(schema, estateComparisonDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(estateComparisonDetails);

        setIsTableHide(true);

        const result = await services.getEstateComparisonReportData(estateComparisonDetails);
        var pluckingResult = result.pluckingResult;
        var factoryResult = result.factoryResult;
        var fieldResult = result.fieldResult;
        var otherEstatesResult = result.otherEstatesResult;

        var finalReportData = [];
        var fromattedPluckingResultData = [];

        pluckingResult.forEach(x => {

            if (fromattedPluckingResultData.length === 0) {
                x.pformattedDate = x.date.split('T')[0];
                fromattedPluckingResultData.push(x);
            } else {

                var selectedResult = fromattedPluckingResultData.find(y => y.date === x.date);

                if (selectedResult) {
                    selectedResult.pformattedDate = x.date.split('T')[0];
                    selectedResult.pluckingGrossWeight = generateSumValues(selectedResult.pluckingGrossWeight, x.pluckingGrossWeight);
                    selectedResult.pluckingRoundedWeight = generateSumValues(selectedResult.pluckingRoundedWeight, x.pluckingRoundedWeight);
                    selectedResult.pluckingDeduction = generateSumValues(selectedResult.pluckingDeduction, x.pluckingDeduction);
                    selectedResult.pluckingNetWeight = generateSumValues(selectedResult.pluckingNetWeight, x.pluckingNetWeight);
                } else {
                    x.pformattedDate = x.date.split('T')[0];
                    fromattedPluckingResultData.push(x)
                }
            }

        });

        factoryResult.forEach(x => {
            x.fformattedDate = x.date.split('T')[0];
        });

        fieldResult.forEach(x => {
            x.fiformattedDate = x.date.split('T')[0];
        });

        otherEstatesResult.forEach(x => {
            x.oformattedDate = x.date.split('T')[0];
        });

        var joinedArray = _.merge(_.keyBy(fromattedPluckingResultData, 'pformattedDate'), _.keyBy(factoryResult, 'fformattedDate'),
            _.keyBy(fieldResult, 'fiformattedDate'), _.keyBy(otherEstatesResult, 'oformattedDate'));
        Object.keys(joinedArray).forEach(x => finalReportData.push(joinedArray[x]));

        for (const item of finalReportData) {
            totalOfData.pluckingGrossWeight += (item.pluckingGrossWeight === undefined) ? 0 : item.pluckingGrossWeight;
            totalOfData.pluckingRoundedWeight += (item.pluckingRoundedWeight === undefined) ? 0 : item.pluckingRoundedWeight;
            totalOfData.pluckingDeduction += (item.pluckingDeduction === undefined) ? 0 : item.pluckingDeduction;
            totalOfData.pluckingNetWeight += (item.pluckingNetWeight === undefined) ? 0 : item.pluckingNetWeight;
            totalOfData.fieldBagCount += (item.fieldBagCount === undefined) ? 0 : item.fieldBagCount;
            totalOfData.fieldGrossWeight += (item.fieldGrossWeight === undefined) ? 0 : item.fieldGrossWeight;
            totalOfData.fieldNetWeight += (item.fieldNetWeight === undefined) ? 0 : item.fieldNetWeight;
            totalOfData.fieldPerBagAverage += (item.fieldPerBagAverage === undefined) ? 0 : item.fieldPerBagAverage;
            totalOfData.factoryBagCount += (item.factoryBagCount === undefined) ? 0 : item.factoryBagCount;
            totalOfData.factoryGrossWeight += (item.factoryGrossWeight === undefined) ? 0 : item.factoryGrossWeight;
            totalOfData.factoryDeduction += (item.factoryDeduction === undefined) ? 0 : item.factoryDeduction;
            totalOfData.factoryNetWeight += (item.factoryNetWeight === undefined) ? 0 : item.factoryNetWeight;
            totalOfData.factoryPerBagAverage += (item.factoryPerBagAverage === undefined) ? 0 : item.factoryPerBagAverage;
            totalOfData.otherEstatesGrossWeight += (item.otherEstatesGrossWeight === undefined) ? 0 : item.otherEstatesGrossWeight;
        }

        for (const item of finalReportData) {
            for (const property in totalOfData) {
                if (item[property] !== undefined) {
                    item[property] = (property === "factoryBagCount" || property === "fieldBagCount") ?
                        Number(item[property]) : Number(item[property]).toFixed(2);
                }
                if (totalOfData[property] !== 'Total') {
                    totalOfData[property] = (property === "factoryBagCount" || property === "fieldBagCount") ? Number(totalOfData[property]) :
                        Number(totalOfData[property]).toFixed(2);
                }
            }
        }

        const sumValues = [totalOfData];
        finalReportData.forEach(x => {
            x.date = x.date.split('T')[0];
        });
        setReportData(finalReportData);

        setTotalCollections(sumValues[0]);

        destroyDataTable();
        setIsTableHide(false);
        setIsReportButtonsEnabled(true);
        setButtonHide(false);
        createDataTable();

        generateCsvData(finalReportData, sumValues, reportData)
    }

    function generateSumValues(firstVal, secVal) {
        var res = (firstVal === undefined ? 0 : firstVal) + (secVal === undefined ? 0 : secVal);
        return res;
    }

    function generateCsvData(finalReportData, sumValues) {
        var deepCopyofFinalResult = _.cloneDeep(finalReportData);
        var newCopy = [];

        deepCopyofFinalResult.forEach(x => {
            let newRecord = {};
            for (const key in sumValues[0]) {
                if (x.date) {
                    newRecord.dateTime = x.date.split('T')[0];
                }
                newRecord[key] = (x[key] === undefined) ? '0.00' : x[key]
            }
            newCopy.push(newRecord)
        });

        const completeData = [...newCopy, ...sumValues];
        setCsvData(completeData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Estate Comparison Report',
            fileName: 'EstateComparisonReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)

        var newRow1 = {
            dateTime: "Group :" + groups[estateComparisonDetails.groupID],
            pluckingRoundedWeight: "Estate : " + estates[estateComparisonDetails.estateID]
        }
        var newRow2 = {
            dateTime: "From Date : " + estateComparisonDetails.fromDate,
            pluckingRoundedWeight: "To Date : " + estateComparisonDetails.toDate
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {

        setEstateComparisonDetails({
            groupID: "0",
            estateID: "0",
            fromDate: "",
            toDate: ""
        });
        setIsTableHide(true);
        setErrors("");
        setIsReportButtonsEnabled(false);
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Estate Comparison Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={estateComparisonDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={estateComparisonDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                </div>


                                <div className="row">
                                    <div className="col-md">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>


                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>


                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, estateComparisonDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            <div className="table-responsive row-top-gap">
                                                <table id="example" className="display dataTable no-footer">
                                                    <thead>
                                                        <tr>
                                                            <th rowspan="2"> Date </th>
                                                            <th colspan="4" style={{ background:"lightgreen",textAlign: "right" }}> <center>Plucker collection </center> </th>
                                                            <th colspan="4" style={{ background:"lightgreen",textAlign: "right" }}> <center>Field collection </center></th>
                                                            <th colspan="5" style={{ background:"lightgreen",textAlign: "right" }}><center>Factory collection </center></th>
                                                            <th colspan="1"> <center>Other Estates </center></th>
                                                        </tr>
                                                        <tr>
                                                            <th>Gross weight</th>
                                                            <th>Net weight</th>
                                                            <th>Deduction</th>
                                                            <th>Rounded Weight</th>
                                                            <th>Bag count</th>
                                                            <th>Gross weight</th>
                                                            <th>Net weight</th>
                                                            <th>Per bag average</th>
                                                            <th>Bag count</th>
                                                            <th>Gross weight</th>
                                                            <th>Deduction</th>
                                                            <th>Net weight</th>
                                                            <th>Per bag average</th>
                                                            <th>GrossWeight</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <EstateComparisonTableContent
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr style={{ textAlign: "right" }}>
                                                            <td><h6>Total</h6></td>
                                                            <td><h6>{totalCollections.pluckingGrossWeight}</h6></td>
                                                            <td><h6>{totalCollections.pluckingRoundedWeight}</h6></td>
                                                            <td><h6>{totalCollections.pluckingDeduction}</h6></td>
                                                            <td><h6>{totalCollections.pluckingNetWeight}</h6></td>
                                                            <td><h6>{totalCollections.fieldBagCount}</h6></td>
                                                            <td><h6>{totalCollections.fieldGrossWeight}</h6></td>
                                                            <td><h6>{totalCollections.fieldNetWeight}</h6></td>
                                                            <td><h6>{totalCollections.fieldPerBagAverage}</h6></td>
                                                            <td><h6>{totalCollections.factoryBagCount}</h6></td>
                                                            <td><h6>{totalCollections.factoryGrossWeight}</h6></td>
                                                            <td><h6>{totalCollections.factoryDeduction}</h6></td>
                                                            <td><h6>{totalCollections.factoryNetWeight}</h6></td>
                                                            <td><h6>{totalCollections.factoryPerBagAverage}</h6></td>
                                                            <td><h6>{totalCollections.otherEstatesGrossWeight}</h6></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Estate Comparison Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys}
                                            totalAmount={totalCollections} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
